export enum LabProvider {
  TRUEPILL = "TRUEPILL",
  BIO_REFERENCE_LAB = "BIO_REFERENCE_LAB",
  GETLABS = "GETLABS",
  PATIENT = "PATIENT"
}
